import { render, staticRenderFns } from "./dashboard-module-shared-components-base-area.vue?vue&type=template&id=d2b4e010&scoped=true&"
import script from "./dashboard-module-shared-components-base-area.ts?vue&type=script&lang=ts&"
export * from "./dashboard-module-shared-components-base-area.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-module-shared-components-base-area.scss?vue&type=style&index=0&id=d2b4e010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b4e010",
  null
  
)

export default component.exports